import React, { useEffect, useState } from "react";
import { AiFillEdit } from "react-icons/ai";
import { isLoggedIn } from "../helpers/authHelper";
import ContentUpdateEditor from "./ContentUpdateEditor";
import Loading from "./Loading";
import UserAvatar from "./UserAvatar";

const Profile = (props) => {
  const [user, setUser] = useState(null);
  const currentUser = isLoggedIn();

  useEffect(() => {
    if (props.profile) {
      setUser(props.profile.user);
    }
  }, [props.profile]);

  const bgVideo = "/videos/banner.mp4";

  if (!user) return <Loading label="Loading profile..." />;

  return (
    <div className="bg-white rounded-2xl shadow-sm overflow-hidden mb-6 border">
      
      {/* Banner */}
      <div className="relative h-40 md:h-48">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-full object-cover"
        >
          <source src={bgVideo} type="video/mp4" />
        </video>

        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 to-black/60" />
      </div>

      {/* Profile Content */}
      <div className="relative px-6 pb-6">
        
        {/* Avatar */}
        <div className="flex justify-center -mt-16">
          <div className="bg-white p-1 rounded-xl shadow-md">
            <UserAvatar
              width={120}
              height={120}
              username={user.username}
              className="rounded-xl"
            />
          </div>
        </div>

        {/* Username */}
        <h2 className="text-center text-2xl font-bold mt-4">
          {user.username}
        </h2>

        {/* Bio */}
        <div className="mt-4">
          {props.editing ? (
            <ContentUpdateEditor
              handleSubmit={props.handleSubmit}
              originalContent={user.biography}
              validate={props.validate}
            />
          ) : (
            <div className="max-w-md mx-auto text-center bg-gray-50 border rounded-xl p-4">
              {user.biography ? (
                <p className="text-gray-700">
                  <span className="font-semibold">Bio:</span>{" "}
                  {user.biography}
                </p>
              ) : (
                <p className="italic text-gray-400">No bio yet</p>
              )}
            </div>
          )}
        </div>

        {/* Actions */}
        <div className="flex justify-center mt-4">
          {currentUser && user._id === currentUser.userId && (
            <button
              onClick={props.handleEditing}
              className="flex items-center gap-2 px-4 py-2 rounded-xl border text-sm font-medium hover:bg-gray-50"
            >
              <AiFillEdit />
              {props.editing ? "Cancel" : "Edit bio"}
            </button>
          )}

          {currentUser && user._id !== currentUser.userId && (
            <button
              onClick={props.handleMessage}
              className="px-6 py-2 rounded-xl bg-gradient-to-r from-violet-600 to-purple-600 text-white text-sm font-semibold hover:opacity-90"
            >
              Message
            </button>
          )}
        </div>

        {/* Stats */}
        <div className="mt-6 pt-4 border-t flex justify-center gap-8 text-sm">
          <div className="text-center">
            <p className="font-bold text-gray-900">
              {props.profile.posts.likeCount}
            </p>
            <p className="text-gray-500">Likes</p>
          </div>

          <div className="text-center">
            <p className="font-bold text-gray-900">
              {props.profile.posts.count}
            </p>
            <p className="text-gray-500">Posts</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
